<div
  ngbDropdown
  display="dynamic"
  placement="bottom-right"
  #myDrop="ngbDropdown"
  routerLink="/checkout"
  [ngClass]="{ 'cart-button-white': isRef }"
  (mouseenter)="$event.stopPropagation(); myDrop.open()"
  (mouseleave)="$event.stopPropagation(); myDrop.close()"
>
  <div class="d-block">
    <button class="btn cart-button" role="button" id="cartIcon" ngbDropdownAnchor>
      <span *ngIf="isRef && !!cartContents" class="mr-1 small">{{
        cartContents.totalValue | gungCurrency: cartContents.currency
      }}</span>
      <i [ngClass]="cartContents ? 'fas fa-shopping-cart' : 'fa fa-spinner fa-pulse fa-fw'"></i>
      <span *ngIf="!!cartContents" [ngClass]="isRef ? 'badge' : 'badge text-dark'">{{ cartContents.rows.length }}</span>
    </button>
    <div ngbDropdownMenu aria-labelledby="cartIcon">
      <div class="cart-content container" *ngIf="!!cartContents">
        <div class="row justify-content-end">
          <div class="col-12 d-flex flex-row flex-wrap">
            <button
              type="button"
              class="btn btn-outline-secondary btn-sm w-100"
              (click)="$event.preventDefault(); $event.stopPropagation(); clearCart()"
              translate
            >
              CLEAR_CART
            </button>

            <button
              type="button"
              class="btn btn-sm btn-outline-secondary w-100 mt-2"
              (click)="$event.preventDefault(); $event.stopPropagation(); saveCart()"
              translate
            >
              SAVE_CART
            </button>

            <button
              type="button"
              class="btn btn-outline-secondary btn-sm w-100 mt-2"
              routerLink="/checkout"
              (click)="$event.preventDefault(); $event.stopPropagation(); myDrop.close()"
              translate
            >
              CHECKOUT
            </button>
          </div>
        </div>
        <div class="row table-row">
          <div class="col">
            <table class="table table-sm table-borderless">
              <tbody>
                <tr *ngFor="let row of cartContents.rows">
                  <td>
                    <a routerLink="/product/{{ row.cartRow.productId }}">{{ row.cartRow.productId }}</a>
                  </td>
                  <td>x{{ row.cartRow.qty }}</td>
                  <td class="text-right">
                    {{
                      row.price.cartRowUnitPriceInclRowDiscount.value
                        | gungCurrency: row.price.cartRowUnitPriceInclRowDiscount.currencyCode
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <hr style="width: 96%; margin-left: 2%" />
        <div class="row">
          <div class="col-12 text-right">
            <h5>
              {{ cartContents.totalValue | gungCurrency: cartContents.currency }}
            </h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
